import { v4 as uuidv4 } from 'uuid'
import { AnimalHistoricDTO } from 'src/dto/animal.dto'

export interface AnimalHistoricParams {
  idFazenda: string
  idAnimal: string
  idHistorico?: string
  idFazendaIdAnimal?: string
  idTransacao?: string | null
  data?: string
  peso: number | null
  perimetro?: number
  observacoes?: string
  compra?: boolean
  nascimento?: boolean
  morte?: boolean
  venda?: boolean
  diagnostico?: string | null
  status?: string
  fitaComprimento?: number
  fitaPerimetro?: number
  idProcessoMangueiro?: string | null
  categoria?: string
  idPasto?: string
  descricao?: string
  sexo?: string
  animalComprado?: boolean
  idLote?: string
  meses?: number
  ganhoDePeso?: number
  acao?: string
  tela?: string
}

export class AnimalHistoric implements AnimalHistoricDTO {
  idFazenda: string
  idAnimal: string
  idHistorico: string
  idFazendaIdAnimal?: string
  idTransacao: string | null
  data: string
  peso: number | null
  perimetro: number | null
  observacoes: string
  compra: boolean
  nascimento?: boolean
  morte: boolean | null
  venda: boolean | null
  diagnostico: string | null
  status: string
  fitaComprimento: number | null
  fitaPerimetro: number | null
  sync = false
  idProcessoMangueiro: string | null
  acao = 'Atualizacao'
  tela: string
  categoria?: string
  idPasto?: string
  descricao?: string
  sexo?: string
  animalComprado?: boolean
  idLote?: string
  meses?: number
  ganhoDePeso?: number

  constructor({
    idFazenda,
    idAnimal,
    idHistorico = uuidv4(),
    idFazendaIdAnimal,
    idTransacao = uuidv4(),
    data = new Date().toISOString(),
    peso = 0,
    perimetro = 0,
    observacoes = '',
    compra = false,
    nascimento = false,
    morte = false,
    venda = false,
    diagnostico = null,
    status = 'pendente',
    fitaComprimento = 0,
    fitaPerimetro = 0,
    idProcessoMangueiro = null,
    categoria,
    idPasto = '',
    descricao,
    sexo,
    animalComprado = false,
    idLote = '',
    meses = 0,
    ganhoDePeso = 0,
    acao = 'Atualizacao',
    tela = 'cadastroAnimal'
  }: AnimalHistoricParams) {
    this.idFazenda = idFazenda
    this.idAnimal = idAnimal
    this.idHistorico = idHistorico
    this.idFazendaIdAnimal = idFazendaIdAnimal
    this.idTransacao = idTransacao
    this.data = data
    this.peso = peso
    this.perimetro = perimetro
    this.observacoes = observacoes
    this.compra = compra
    this.nascimento = nascimento
    this.morte = morte
    this.venda = venda
    this.diagnostico = diagnostico
    this.status = status
    this.fitaComprimento = fitaComprimento
    this.fitaPerimetro = fitaPerimetro
    this.idProcessoMangueiro = idProcessoMangueiro
    this.categoria = categoria
    this.idPasto = idPasto
    this.descricao = descricao
    this.sexo = sexo
    this.animalComprado = animalComprado
    this.idLote = idLote
    this.meses = meses
    this.ganhoDePeso = ganhoDePeso
    this.acao = acao
    this.tela = tela
  }
}
